
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8iqII", function(module, exports) {
const $60a4bb42e9714cf5$var$open = document.querySelector(".js-modal-open");
const $60a4bb42e9714cf5$var$close = document.querySelector(".js-modal-close");
const $60a4bb42e9714cf5$var$modal = document.querySelector(".js-backdrop");
$60a4bb42e9714cf5$var$open.addEventListener("click", $60a4bb42e9714cf5$var$openModal);
$60a4bb42e9714cf5$var$close.addEventListener("click", $60a4bb42e9714cf5$var$closeModal);
function $60a4bb42e9714cf5$var$openModal() {
    $60a4bb42e9714cf5$var$modal.classList.remove("is-hidden");
    document.body.classList.add("no-scroll");
    document.addEventListener("keydown", $60a4bb42e9714cf5$var$closeModalWithEsc);
    $60a4bb42e9714cf5$var$modal.addEventListener("click", $60a4bb42e9714cf5$var$closeModalBackdropClick);
}
function $60a4bb42e9714cf5$var$closeModal() {
    $60a4bb42e9714cf5$var$modal.classList.add("is-hidden");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("keydown", $60a4bb42e9714cf5$var$closeModalWithEsc);
    $60a4bb42e9714cf5$var$modal.removeEventListener("click", $60a4bb42e9714cf5$var$closeModalBackdropClick);
}
function $60a4bb42e9714cf5$var$closeModalWithEsc(e) {
    if (e.code === "Escape") $60a4bb42e9714cf5$var$closeModal();
}
function $60a4bb42e9714cf5$var$closeModalBackdropClick(e) {
    if (e.target === $60a4bb42e9714cf5$var$modal) $60a4bb42e9714cf5$var$closeModal();
}

});

parcelRegister("bUb57", function(module, exports) {
const $8aad853c076397e7$var$homeLink = document.querySelector(".js-home-link");
const $8aad853c076397e7$var$aboutLink = document.querySelector(".js-about-link");
const $8aad853c076397e7$var$productsLink = document.querySelector(".js-products-link");
const $8aad853c076397e7$var$contactsLink = document.querySelector(".js-contacts-link");
const $8aad853c076397e7$var$aboutPage = document.querySelector(".about-container");
const $8aad853c076397e7$var$productsPage = document.querySelector(".products-container");
const $8aad853c076397e7$var$contactsPage = document.querySelector(".contacts-container");
if ($8aad853c076397e7$var$aboutPage) $8aad853c076397e7$var$aboutLink.classList.add("header-active-link");
else if ($8aad853c076397e7$var$productsPage) $8aad853c076397e7$var$productsLink.classList.add("header-active-link");
else if ($8aad853c076397e7$var$contactsPage) $8aad853c076397e7$var$contactsLink.classList.add("header-active-link");
else $8aad853c076397e7$var$homeLink.classList.add("header-active-link");

});

parcelRequire("8iqII");
parcelRequire("bUb57");


//# sourceMappingURL=terms.5d4b75a0.js.map
